import * as React from "react";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";

interface ListLoadFailedAlertProps {
  show?: boolean;
}

/**
 * Warns that the last list request failed, so the rows on screen are left
 * over from an earlier load and may not match the current page/sort/filter.
 */
export function ListLoadFailedAlert({ show }: ListLoadFailedAlertProps) {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <Alert severity="warning" role="alert" sx={{ mb: 1 }}>
      {t(messages.List_Load_Failed())}
    </Alert>
  );
}
